import { themeStyle } from '@repo/ui/theming';

export const defaultTheme = {
  color: themeStyle.varInkMedium,
  activeColor: themeStyle.varInkMain,
  activeDefaultColor: themeStyle.varInkMain,
  transition: '0.3s',

  background: themeStyle.varBackgroundAlt,
  backgroundActive: themeStyle.varBackgroundAlt,
  borderColor: themeStyle.varInkLight,
  boxShadow: themeStyle.shadowMedium,
};
